import React from 'react'
import {darkGray} from '@modifi/colors'

import STYLE_CONSTANTS from './constants'

export const GlobalStyles = () => (
  <style
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{
      __html: `
      html {
        box-sizing: border-box;
        font-size: 16px;
        color: ${({color = darkGray}) => color};
      }
    
      *,
      *::before,
      *::after {
        box-sizing: inherit;
      }
    
      body {
        margin: 0;
        padding: 0;
        font-family: ${STYLE_CONSTANTS.FONT_FAMILY};
        font-weight: ${STYLE_CONSTANTS.FONT_WEIGHT_REGULAR};
      }
    
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      strong {
        font-weight: ${STYLE_CONSTANTS.FONT_WEIGHT_BOLD};
      }
`,
    }}
  />
)
